import React, {Component} from "react";
import {List as ImmutableList, Map, OrderedMap} from 'immutable';
import PropTypes from 'prop-types';
import connect from '../store/connect';

import GlobalSearchField from "./GlobalSearchField";
import GlobalSearchResults from "./GlobalSearchResults";

import {
	fetchSearchFilters,
	fetchGlobalSearch,
	setViewstate,
} from "../actions/actionCreators";

import {
	getFilteredResults,
	getSearchTabs
} from "../selectors/globalSearch";

import * as K from "../constants/constants";

class GlobalSearch extends Component {

	constructor(props) {
		super(props);

		this.searchSubmitHandler = this.searchSubmitHandler.bind(this);
		this.searchChangeHandler = this.searchChangeHandler.bind(this);
		this.searchFilterHandler = this.searchFilterHandler.bind(this);
		this.searchToggleHandler = this.searchToggleHandler.bind(this);
		//console.log("location search : " , this.props.history.location.search);
		let loc = this.props.history.location;
		this.state = {
			isOpen : ( loc.search && loc.pathname === K.URI_SEARCH ? true : false)
		}
	}

	componentDidMount() {
		let isDev = process.env.NODE_ENV === "development";
		this.props.fetchSearchFilters({url: isDev ? K.URL_DATA_FILTERS_SEARCH_DEV : K.URL_DATA_FILTERS_SEARCH});
	}

	// From http://joncom.be/code/javascript-querystring-values/
	extractQueryString() {
	    var oResult = {};
		let locationSearch = decodeURI(document.location.search);
	    var aQueryString = (locationSearch.substr(1)).split("&");

		if (aQueryString.length <= 1 ) {
			return "";
		}
	    for (var i = 0; i < aQueryString.length; i++) {
	        var aTemp = aQueryString[i].split("=");
	        if (aTemp[1].length > 0) {
	            oResult[aTemp[0]] = unescape(aTemp[1]);
	        }
	    }
	    return oResult;
	}

	searchChangeHandler(val) {
 		//console.log("got changes : " , val);
	}
	searchSubmitHandler(val) {
		//console.log("got submit : " , val);
		this.props.setViewstate("globalSearchQuery", val);
	}
	searchFilterHandler(val) {
		this.props.setViewstate("globalSearchFilter", val);
	}
	searchToggleHandler() {
		this.setState({"isOpen": !this.state.isOpen} );
	}

	updateHistory() {
		let queryVal = this.props.globalSearchQuery || undefined;
		let filterKey = this.props.globalSearchFilter || this.props.searchFilters.keySeq().first();
		let filterVal = queryVal ? this.props.searchFilters.getIn([filterKey, "path"]) : undefined;

		// Don't rewrite the history if there isn't a need to do so.
		if (!filterVal) {
			this.props.history.location.search = "";
			this.props.history.location.hash = "";
			return;
		}

		this.props.history.push({
			pathname: K.URI_SEARCH,
			search: `?filter=${encodeURI(filterVal)}&query=${encodeURI(queryVal)}`
		})
	}

	resetSearchParams() {
		this.props.setViewstate('globalSearchQuery', undefined);
		this.props.setViewstate('globalSearchFilter', undefined);
	}

	UNSAFE_componentWillReceiveProps( nextProps ) {
		// SearchFilters gets updated only once after they are loaded
		if ( nextProps.searchFilters !== this.props.searchFilters ) {

			let searchParams = this.extractQueryString();
			let filtr = searchParams["filter"] || "";
			let query = searchParams["query"] || "";
			let key = nextProps.searchFilters.findKey( obj => obj.get("path") === filtr ) || nextProps.searchFilters.keySeq().first();
			this.props.setViewstate('globalSearchQuery', query);
			this.props.setViewstate('globalSearchFilter', key);
		}
	}

	UNSAFE_componentWillUpdate( nextProps, nextState ) {
		// Remove this stuff!
		/*if ( nextState.isOpen !== this.state.isOpen && !nextState.isOpen ) {
			this.resetSearchParams();
			this.updateHistory();
		}*/
	}
	componentDidUpdate(prevProps, prevState) {

		if( prevProps.globalSearchQuery !== this.props.globalSearchQuery ) {
			let url = "";

			// if( process.env.NODE_ENV === "development" ) {
			// 	url = this.props.globalSearchQuery === "sundsvall" ? K.URL_GLOBAL_SEARCH_DEV : K.URL_GLOBAL_SEARCH_DEV_2;
			// } else {
			// }
			url = process.env.NODE_ENV === "development" ? K.URL_GLOBAL_SEARCH_DEV : K.URL_GLOBAL_SEARCH;
			url += `?query=${encodeURI(this.props.globalSearchQuery)}`;

			// Make a decision to fetch a query from the server or use cached value.
			// Look at UTC timestamp.
			if (this.props.globalSearchResults.size < 1) {

				// let url = process.env.NODE_ENV === "development" ? K.URL_GLOBAL_SEARCH_DEV : K.URL_GLOBAL_SEARCH;
				this.props.fetchGlobalSearch({
					url: url,
					queryString: this.props.globalSearchQuery
				});
			} else {
				// console.log(" got results from cache");
			}
			let isOpen = this.props.globalSearchQuery ? true : false;

			this.setState({"isOpen" : isOpen} );
			this.updateHistory();
		}

		if ( prevProps.globalSearchFilter !== this.props.globalSearchFilter ) {
			this.updateHistory();
		}
	}


	render() {
		return (
			<div>
				<GlobalSearchField
					onSearchChange={this.searchChangeHandler}
					onSearchSubmit={this.searchSubmitHandler}
					onSearchFilter={this.searchFilterHandler}
					onSearchToggle={this.searchToggleHandler}
					placeholder={K.SEARCH_PLACEHOLDER}
					textValue={this.props.globalSearchQuery}
					tabs={this.props.searchTabs}
					isOpen={this.state.isOpen}
					numberOfSearchResult={this.props.globalSearchResults.size}
				/>
				{ this.state.isOpen ?
				<GlobalSearchResults
					searchResults={this.props.globalSearchResults}
                    globalSearchFilter={this.props.globalSearchFilter}
				/> : null }
			</div>
		);
	}
}

GlobalSearch.propTypes = {
	fetchSearchFilters: PropTypes.func,
	fetchGlobalSearch: PropTypes.func,
	globalSearchResults: PropTypes.object,
	globalSearchQuery: PropTypes.string,
	getFilteredResults: PropTypes.func,
	getSearchTabs: PropTypes.func,
	globalSearchFilter: PropTypes.string,
	searchFilters:PropTypes.object,
	searchTabs: PropTypes.object,
	resultTypes: PropTypes.object,
}
GlobalSearch.defaultProps = {
	fetchSearchFilters: () => {},
	fetchGlobalSearch: () => {},
	globalSearchResults: ImmutableList(),
	globalSearchQuery: "",
	getFilteredResults:() => {},
	getSearchTabs: () => {},
	globalSearchFilter: "",
	searchFilters:Map(),
	searchTabs: ImmutableList(),
	resultTypes: Map(),
}

export default connect(
	GlobalSearch,
	{
		fetchSearchFilters,
		fetchGlobalSearch,
		setViewstate,
	},
	(store, props)=>({
		globalSearchResults: getFilteredResults(store, props),
		globalSearchQuery: store.viewstate.get("globalSearchQuery"),
		globalSearchFilter: store.viewstate.get("globalSearchFilter"),
		searchFilters: store.searchFilters,
		searchTabs: getSearchTabs(store, props),
		// resultTypes: store.globalSearchResults.get("types"),
	})
);



// WEBPACK FOOTER //
// ./src/js/components/GlobalSearch.js